import { Controller, Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AssetLicense } from "./entity/asset-license.entity";
import { AssetLicenseRepository } from "./repository/asset-license.repository";
import { AssetLicenseController } from "./asset-license.controller";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { AssetLicenseAdapter } from "./entity/asset-license.adapter";
import { AssetLicenseService } from "./asset-license.service";
import { LicenseLogsAdapter } from "./entity/license-log.adapter";
// import { assetMainanceTransactions } from "./entity/license-log.entity";
import { LicenseLogRepository } from "./repository/license-log.repository";
import { assetsLogTransactions } from "./entity/license-log.entity";

@Module({
    imports:[TypeOrmModule.forFeature([AssetLicense,AssetLicenseRepository,LicenseLogRepository,assetsLogTransactions]),],
    controllers:[AssetLicenseController],
    providers :[AssetLicenseService,AssetLicenseAdapter,LicenseLogsAdapter,ApplicationExceptionHandler],
    exports:[AssetLicenseService]
}

)
export class AssetLicenseModule{}